import React, { useState, useEffect } from 'react'
import LoanPortfolioReviewDash from './LoanPortfolioReview'

import Image1Inactive from '../../../Marketing/newdesigns/imagesmarket/Group (9).png'
import Image1active from '../../../Marketing/newdesigns/imagesmarket/Group (10).png'
import Image2Inactive from '../../../Marketing/newdesigns/imagesmarket/stats (2).png'
import Image2active from '../../../Marketing/newdesigns/imagesmarket/stats (1).png'
import Image3Inactive from '../../../Marketing/newdesigns/imagesmarket/stats (3).png'
import Image3active from '../../../Marketing/newdesigns/imagesmarket/Vector (29).png'
import Image4Inactive from '../../../Marketing/newdesigns/imagesmarket/stats (4).png'
import Image4active from '../../../Marketing/newdesigns/imagesmarket/stats (5).png'
import Image5Inactive from '../../../Marketing/newdesigns/imagesmarket/range-slider.png'
import Image5active from '../../../Marketing/newdesigns/imagesmarket/range-slider (1).png'
import Image7Inactive from '../../../Marketing/newdesigns/imagesmarket/Vector (30).png'
import Image7active from '../../../Marketing/newdesigns/imagesmarket/statistic-down.png'
import Image8Inactive from '../../../Marketing/newdesigns/imagesmarket/business (2).png'
import Image8active from '../../../Marketing/newdesigns/imagesmarket/business (3).png'
import { subtractOneDay, reverseFormat, todayDate, monthStartDate, formatDate } from '../../../Marketing/maketingComponents/utils/utils'

import LeadParticulars from "./LeadParticular";
import StatewiseData from "./StateWiseData";
import RejectionStats from "./RejectionStats";
import AgestatusData from "./AgeStats";
import SalaryRange from "./SalaryRange";
import LoanStatusData from "./LoanstatusData";
import ConversionRatio from "./ConversionRatio";
import DeviationReport from "./DeviationChart";
import GenderStats from "./GenderStats";
import EmiSats from "./EMIStats";
import BuisnessAggregator from "./BuisnessAggregator";
import Formstatus from './FormStatusStats'



export default function Main({ nbfcList, admin, allStatus, newDataBackground }) {
    const [nbfcFilter, setnbfcFilter] = useState("")
    const [dateType, setdateType] = useState("disburseDate")
    const [liveReportTab, setLiveReportTab] = useState('leadParticular')
    const [applyFilter, setApplyFilter] = useState(false)
    const [today, setToday] = useState(todayDate())
    const [payload, setPayload] = useState({
        fromDate: monthStartDate(),
        toDate: todayDate(),
        minDate: monthStartDate(),
    });

    const handleChange = (e, type) => {
        if (type === "nbfcFilter") {
            setnbfcFilter(e.target.value)
        } else if (type === "fromDate") {
            setPayload({
                ...payload,
                fromDate:
                    e.target.type === "date"
                        ? formatDate(e.target.value)
                        : e.target.value,
                toDate: payload.toDate,
            });
        } else if (type === "toDate") {
            setPayload({
                ...payload,
                [e.target.name]:
                    e.target.type === "date"
                        ? formatDate(e.target.value)
                        : e.target.value,
                fromDate: payload.fromDate,
            });
        } else if (type === "dateType") {
            setdateType(e.target.value)
        }
    }

    const handlApplyFilter = () => {
        setApplyFilter(true)
    }

    const clearApplyFilter = () => {
        setApplyFilter(false)
    }
    return (
        <>
            <div className="row fixed-top" style={{ marginTop: '62px', fontSize: '14px', width: 'auto', left: '0', right: '0' }}>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'leadParticular' ? "active" : ""}`} onClick={() => setLiveReportTab('leadParticular')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'leadParticular' ? Image1active : Image1Inactive} width={'20px'} />
                    <br />
                    Lead <br />Particulars
                </div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'stateWise' ? "active" : ""}`} onClick={() => setLiveReportTab('stateWise')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'stateWise' ? Image2active : Image2Inactive} width={'20px'} />
                    <br />
                    State wise<br /> Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'rejectReason' ? "active" : ""}`} onClick={() => setLiveReportTab('rejectReason')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'rejectReason' ? Image3active : Image3Inactive} width={'20px'} />
                    <br />
                    Reject Reason <br />Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'genderStats' ? "active" : ""}`} onClick={() => setLiveReportTab('genderStats')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'genderStats' ? Image4active : Image4Inactive} width={'20px'} />
                    <br />
                    Gender<br /> Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'ageStats' ? "active" : ""}`} onClick={() => setLiveReportTab('ageStats')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'ageStats' ? Image4active : Image4Inactive} width={'20px'} />
                    <br />
                    Age <br />Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'salaryRange' ? "active" : ""}`} onClick={() => setLiveReportTab('salaryRange')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'salaryRange' ? Image5active : Image5Inactive} width={'20px'} />
                    <br />
                    Salary <br />Range</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'emiStats' ? "active" : ""}`} onClick={() => setLiveReportTab('emiStats')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'emiStats' ? Image4active : Image4Inactive} width={'20px'} />
                    <br />
                    EMI<br /> Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'loanStatus' ? "active" : ""}`} onClick={() => setLiveReportTab('loanStatus')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'loanStatus' ? Image4active : Image4Inactive} width={'20px'} />
                    <br />
                    Loan Status <br />Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'formStatus' ? "active" : ""}`} onClick={() => setLiveReportTab('formStatus')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'formStatus' ? Image4active : Image4Inactive} width={'20px'} />
                    <br />
                    Form Status <br />Stats</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'conversionRatio' ? "active" : ""}`} onClick={() => setLiveReportTab('conversionRatio')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'conversionRatio' ? Image4active : Image4Inactive} width={'20px'} />
                    <br />
                    Conversion <br />Ratio</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'deviation' ? "active" : ""}`} onClick={() => setLiveReportTab('deviation')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'deviation' ? Image7active : Image7Inactive} width={'20px'} />
                    <br />
                    Deviation <br />Chart</div>
                <div className={`col-sm-1 col-xs-12 marketing-sub-tab Live_reports_tabs ${liveReportTab === 'businessAgreegator' ? "active" : ""}`} onClick={() => setLiveReportTab('businessAgreegator')} style={{ height: '93px' }}>
                    <img src={liveReportTab === 'businessAgreegator' ? Image8active : Image8Inactive} width={'20px'} />
                    <br />
                    Business from <br />Aggregators</div>

            </div>
            <div className="MonthDateFilter" style={{ marginBottom: window.innerWidth > 1800 ? '80px' : '50px', marginTop: '100px' }}>
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-xs-12" style={{ marginTop: '4px' }}>
                        From
                        <input
                            type="date"
                            id="startDate"
                            placeholder="DD/MM/YY"
                            name="fromDate"
                            value={reverseFormat(payload.fromDate)}
                            onChange={(e) => handleChange(e, "fromDate")}
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />
                    </div>

                    <div className="col-lg-2 col-md-3 col-xs-12">
                        <div className="filterHeaders" style={{ marginTop: "4px" }}>
                            to
                        </div>

                        <input
                            type="date"
                            id="endDate"
                            name="toDate"
                            max={reverseFormat(subtractOneDay(today))} // Assuming reverseFormat gives the correct date format
                            value={reverseFormat(subtractOneDay(payload.toDate))}
                            onChange={(e) => handleChange(e, "toDate")}
                            placeholder="DD/MM/YY"
                            className="form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />
                    </div>
                    {
                        liveReportTab === 'leadParticular' ?
                            <div className="col-lg-2 col-md-3 col-xs-12">
                                <div className="filterHeaders" style={{ marginTop: "4px" }}>
                                    Date Type
                                    <select className="form-control" value={dateType} onChange={(e) => handleChange(e, "dateType")}>
                                        <option value={''}>Select Value</option>
                                        <option value={'disburseDate'}>Disburse</option>
                                        <option value={'apply'}>Apply</option>

                                    </select>
                                </div>
                            </div>
                            : ''}
                    <div className="col-lg-2 col-md-3 col-xs-12">
                        <div className="inputGrp">
                            <label htmlFor="nbfc" className='labeltag'>NBFC</label>
                            <select className='MonthinputTag' id="nbfc" name="nbfc" value={nbfcFilter} onChange={(e) => handleChange(e, 'nbfcFilter')} style={{ width: '100%' }} >
                                <option value="">ALL</option>
                                {
                                    nbfcList && nbfcList?.length > 0 ? nbfcList?.map((data, index) => {
                                        return (
                                            <option value={data?.nbfcId}>{data?.name}</option>
                                        )
                                    })
                                        : ''}
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-xs-12">
                        <button className='FilterApply' onClick={() => handlApplyFilter()}>Apply Filter</button>
                    </div>

                </div>
            </div>


            <LoanPortfolioReviewDash nbfcId={nbfcFilter} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
            <div style={{ marginBottom: '50px' }}></div>

            {liveReportTab === 'leadParticular' ?
                <LeadParticulars admin={admin} newDataBackground={newDataBackground} allStatus={allStatus} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} dateTypeValue={dateType} />
                : ""}
            {liveReportTab === 'stateWise' ?

                <StatewiseData admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />

                : ""}
            {liveReportTab === 'rejectReason' ?
                <RejectionStats admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'ageStats' ?
                <AgestatusData admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'salaryRange' ?
                <SalaryRange admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'loanStatus' ?
                <LoanStatusData admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'conversionRatio' ?
                <ConversionRatio admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'deviation' ?
                <DeviationReport admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'genderStats' ?
                <GenderStats admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'emiStats' ?
                <EmiSats admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'businessAgreegator' ?
                <BuisnessAggregator admin={admin} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />
                : ""}
            {liveReportTab === 'formStatus' ?

                <Formstatus admin={admin} newDataBackground={newDataBackground} allStatus={allStatus} payload={payload} applyFilter={applyFilter} clearApplyFilter={clearApplyFilter} />

                : ""}
        </>
    )
}
